function resetModalBodyState(): void {
  document
    .querySelectorAll('.modal-backdrop')
    .forEach((backdrop) => backdrop.remove());
  document.body.classList.remove('modal-open');
  document.body.style.removeProperty('padding-right');
}

export function clearOrphanedModalState(): void {
  if (document.querySelector('.modal.show')) {
    return;
  }

  resetModalBodyState();
}

export function clearAllModalState(): void {
  resetModalBodyState();

  document.querySelectorAll<HTMLElement>('.modal').forEach((modal) => {
    modal.classList.remove('show');
    modal.setAttribute('aria-hidden', 'true');
    modal.style.display = 'none';
  });
}
